<template>
  <div
    ref="trackItem"
    v-if="Object.keys(track).length"
    class="track-widget-list__item track-item"
    :class="{
      'active': showTrackInfo,
      'track-item_shouldChangeOdp': track.shouldChangeOdp === '1'
    }"
  >
    <div
      class="track-widget-list__wrapper"
      @click.prevent="onItemClick">
      <span class="track-item__sender">
        <span class="icon-shouldChangeOdp"></span>
        {{track.NameIM}}
      </span>
      <span class="track-item__number-store">{{track.order_id}}</span>
      <span class="track-item__number-bb">{{track.ProgramNumber}}</span>

      <a class="track-item-arrow">
        <svg class="arrow-icon" width="17px" height="14px">
          <use xlink:href="#arrow"></use>
        </svg>
      </a>
    </div>

    <div class="track-details" :class="{'track-details_active': showTrackInfo}">

      <div class="loader-overlay" v-if="showGetPointLoader">
        <span class="loader-img"></span>
      </div>

      <div class="track-details__wrap">

        <div class="track-details__status" v-if="historyStatuses && historyStatuses.length">
          <span class="track-details__title">Статусы отправления</span>

          <b-button
            class="map-schedule__button"
            v-if="!showHistory && historyStatuses.length > 1"
            @click="() => {
              showHistory = !showHistory
            }"
          >
            Показать все статусы <span>({{historyStatuses.length}})</span>
          </b-button>

          <b-button
            class="map-schedule__button"
            v-if="showHistory && historyStatuses.length > 1"
            @click="() => {
              showHistory = !showHistory
            }"
          >
            Свернуть
          </b-button>

          <div class="track-details__details history-step" :class="{'history-step_shadow': !showHistory}" v-if="historyStatuses && historyStatuses.length">
            <div class="track-details__shadow" v-if="!showHistory"></div>

            <div class="track-details__wrap track-details__wrap_history">
              <div class="history-step__item"
                   v-for="(status, index) in historyStatuses"
                   :key="index"
              >
                <span class="history-step__circle"></span>
                <div class="history-step__content">
                  <span
                    v-if="status.status === '49'"
                    class="history-step__name history-step__name_lang-ru"
                  >
                    Внесите паспортные данные в личный кабинет для дальнейшей таможенной обработки заказа
                    <a
                      :href="`https://lk.boxberry.ru/asos/${UTMTags}`"
                      target="_blank"
                      rel="noopener"
                    >
                      https://lk.boxberry.ru/asos/
                    </a>
                  </span>
                  <span
                    v-else-if="status.status === '59'"
                    class="history-step__name history-step__name_lang-ru"
                  >
                    Внесите паспортные данные в личный кабинет для дальнейшей таможенной обработки заказа
                    <a
                      :href="`https://lk.boxberry.ru/pd/${UTMTags}`"
                      target="_blank"
                      rel="noopener"
                    >
                      https://lk.boxberry.ru/pd/
                    </a>
                  </span>
                  <span v-else class="history-step__name history-step__name_lang-ru">{{status.name}}</span>
                  <span class="history-step__name history-step__name_lang-en">{{status.name_site_foreign}}</span>
                  <span class="history-step__date">{{status.date_time}}</span>
                </div>
              </div>
            </div>

            <a
              :href="`https://lk.boxberry.ru/${UTMTags}`"
              target="blank"
              rel="noopener"
              class="track-details__allowStorageDateChange"
              v-if="track.status_code === '140'">Продлить срок хранения →</a>

          </div>
        </div>

        <div class="track-details__info">
          <span class="track-details__title">О заказе</span>

          <div class="track-details-items">

            <div v-if="track.shouldChangeOdp === '1'" class="track-details-item__message-changeOdp message-changeOdp">
              <div class="message-changeOdp__wrap">
                <span class="icon-shouldChangeOdp"></span>
                <p>Внимание! Пункт выдачи, в который направляется ваш заказ приостановил свою работу. Пожалуйста, выберите новый пункт выдачи.</p>
                <p>Приносим свои извинения за неудобства.</p>
                <b-button
                  :href="`https://lk.boxberry.ru/parcels/${UTMTags}`"
                  target="blank"
                  rel="noopener"
                  class="map-schedule__button map-schedule__button_red message-changeOdp__button" >
                  <span>Выбрать другой пункт выдачи</span>
                </b-button>
              </div>
            </div>

            <div class="track-details-item" v-if="historyStatuses && historyStatuses.length">
              <span class="track-details-item__title">Статус заказа:</span>

              <span class="track-details-item__body" style="font-weight: bold; color:#ED1651;" v-if="track.shouldChangeOdp === '1'">Приостановлен</span>
              <span class="track-details-item__body" style="font-weight: bold;" v-else>{{ track.status }}</span>
            </div>

            <div class="track-details-item" v-if="showDeliveryDate">
              <span class="track-details-item__title">Плановая дата доставки:</span>
                <span class="track-details-item__body">
                  <span v-if="track.delivery_date">{{track.delivery_date}}<span v-if="track.deliveryTimeFrom && track.deliveryTimeTo">, c {{track.deliveryTimeFrom}} до {{track.deliveryTimeTo}}</span></span>
                  <span v-else>Уточняется</span>
                </span>
            </div>

            <div class="track-details-item" v-if="showStorageLife">
              <span class="track-details-item__title">Срок хранения:</span>
              <span class="track-details-item__body">{{track.store_date}} (включительно)</span>
            </div>
            <div class="track-details-item" v-if="showToReceive">
              <span class="track-details-item__title">Для получения:</span>
              <div class="track-details-item__body" v-if="track.issueCondition === '1'">
                Паспорт или доверенность
                <b-button :id="'button-question'+track.track_id"
                          class="icon-question d-none d-sm-inline-block"></b-button>
                <b-tooltip :target="'button-question'+track.track_id" placement="bottom" boundary-padding="0" custom-class="tooltip_document" :boundary="this.$refs.trackItem">
                  Для получения посылки третьими лицами необходимо составить доверенность в свободной форме.<br>
                  В доверенности должны быть указаны ФИО получателя и его доверенного лица,<br>
                  а также паспортные данные обеих сторон.<br>
                  Доверенному лицу нужно иметь при себе заполненную доверенность и свой паспорт.<br>
                  Доверенность должна быть заверена нотариусом.
                </b-tooltip>
              </div>
              <div class="track-details-item__body" v-if="track.issueCondition === '2'">
                Код из смс
                <b-button :id="'button-question'+track.track_id"
                          class="icon-question d-none d-sm-inline-block"></b-button>
                <b-tooltip :target="'button-question'+track.track_id" placement="bottom" boundary-padding="0" custom-class="tooltip_sms" :boundary="this.$refs.trackItem">
                  Для получения назовите номер заказа и код из Push/vk/viber/смс сообщения.<br>
                  Сообщение поступит в момент доставки заказа в пункт выдачи.
                </b-tooltip>
              </div>
            </div>

            <div class="track-details-item" v-if="showToPay">
              <span class="track-details-item__title">К оплате:</span>
              <span class="track-details-item__body">{{track.sum}}</span>
            </div>

            <div class="track-details-item" v-if="showPaymentMethods">
              <span class="track-details-item__title">Способы оплаты:</span>
              <span class="track-details-item__body">
                Наличный
                <template v-if="acquiring">
                  или безналичный
                </template>
                расчет при получении</span>
            </div>

<!--            <div class="track-details-item">-->
<!--              <span class="track-details-item__title"></span>-->
<!--              <div class="track-details-item__body" v-if="track.payType === '3'">-->
<!--                <div class="track-details-item__aquaring field-aquaring">-->
<!--                  <span class="field-aquaring__title">или оплатите заказ онлайн</span>-->
<!--                  <b-button href="https://lk.boxberry.ru/" class="map-schedule__button map-schedule__button_red field-aquaring__button">-->
<!--                    <span>Оплатить</span>-->
<!--                  </b-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="track-details-item">-->
<!--              <span class="track-details-item__title">Вес товара:</span>-->
<!--              <span class="track-details-item__body">{{Number.parseFloat(track.Weight).toFixed(1)}} кг</span>-->
<!--            </div>-->

            <div class="track-details-item" v-if="track.delivery_type === '2' && track.addressCD">
              <span class="track-details-item__title">Адрес доставки:</span>
              <span class="track-details-item__body">{{track.addressCD}}</span>
            </div>

            <div class="track-details-item" v-if="track.delivery_type === '1' && track.point_address">
              <span class="track-details-item__title">Пункт выдачи:</span>
              <div class="track-details-item__body">
                <a  :href="'/find_an_office/'+track.Code" target="_blank">{{track.point_address}}</a>
              </div>
            </div>

            <div class="track-details-item track-details-item_map-link" v-if="!findPointError">
              <span class="track-details-item__title"></span>
              <div class="track-details-item__body">
                <a @click.prevent="onToggleShowMap" v-if="track.delivery_type === '1'" class="track-details-item__map-link">
                  {{ !showMap ? 'Показать на карте' : 'Скрыть карту' }}
                </a>
              </div>
            </div>

            <div class="track-details-item" v-if="findPointError">
              <span class="track-details-item__title"></span>
              <span class="track-details-item__body" style="color: #ED1651;">Просмотр данных недоступен</span>
            </div>

            <div class="track-details__map" v-if="showMap" style="height: 300px; width: 100%; margin-bottom: 40px;">
              <YmapsView
                :odp="odp"
              />
            </div>

            <div class="track-details-item" v-if="showSchedule">
              <BranchWorkSchedule :odp="odp" />
            </div>

          </div>
        </div>

        <div class="track-details-helper">
          <div class="track-details-helper__left">
            <div class="track-details-helper__title" v-html="'Следите за отправлениями в&nbsp;\n'+
'              <span>мобильном</span> приложении Boxberry'">
            </div>

            <a href="#" @click.prevent="onShowModal" class="track-details-helper__qr" target="_blank">
              <span class="icon-qr-code"></span>
              <span>Скачать по QR-коду</span>
            </a>

            <MobileStoresShopLinks
              :googlePlayLink="googlePlayLink"
              :appStoreLink="appStoreLink"
              :huaweiLink="huaweiLink"
            />

          </div>
          <div class="track-details-helper__center">
            <div class="track-details-helper__title">Оформляйте посылки в 2 клика через личный кабинет</div>
            <a
              :href="`https://lk.boxberry.ru/${UTMTags}`"
              class="track-details-helper__lk" target="_blank" rel="noopener">
              <span class="icon-lk"></span>
              <span>Войти в личный кабинет</span>
            </a>
          </div>
          <div class="track-details-helper__right">
            <div class="track-details-helper__title">Возникли вопросы по доставке или получению?</div>
            <a :href="hrefFaq" class="track-details-helper__question" target="_blank">
              <span class="icon-question"></span>
              <span>Раздел Помощь</span>
            </a>
          </div>
        </div>
      </div>
      <TrackingGift />
    </div>
    <MobileStoresQRCode
      ref="mobileStoresQRCode"
      :qrCodeImageSrc="qrCodeImageSrc"
      @hide="onHideModal"
      v-if="showModal"
    />
  </div>
</template>

<script>
import MobileStoresShopLinks from '../MobileStores/MobileStoresShopLinks.vue';
import MobileStoresQRCode from '../MobileStores/MobileStoresQRCode.vue';
import YmapsView from './YmapsView.vue';
import BranchWorkSchedule from '../BranchWorkSchedule/BranchWorkSchedule.vue';
import * as odpRepository from '../../store/odp.repository';
import UTMTags from '../../mixins/UTMTags';
import TrackingGift from './TrackingGift.vue';

// eslint-disable-next-line
const URL_PREFIX = urlPrefix;

export default {
  name: 'TrackWidgetItem',
  mixins: [UTMTags],
  props: {
    track: Object,
    key: Number,
    forceOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TrackingGift,
    MobileStoresShopLinks,
    MobileStoresQRCode,
    YmapsView,
    BranchWorkSchedule,
  },
  data() {
    return {
      showTrackInfo: false,
      showMap: false,
      showSchedule: false,
      showHistory: false,
      showGetPointLoader: false,
      odp: null,
      findPointError: false,
      googlePlayLink: 'https://redirect.appmetrica.yandex.com/serve/819620577055607550?click_id={tracking}',
      appStoreLink: 'https://redirect.appmetrica.yandex.com/serve/171095109809475009?click_id={tracking}',
      huaweiLink: 'https://appgallery.huawei.com/#/app/C103283299',
      qrCodeImageSrc: 'https://storage.yandexcloud.net/boxberrysite-public/img/qr-code.svg',
      showModal: false,
    };
  },
  computed: {
    orderIssued() {
      return this.track.status_code === '150';
    },
    showToPay() {
      switch (this.track.status_code) {
        case '76':
        case '150':
        case '160':
        case '165':
        case '170':
        case '180':
        case '190':
          return false;
        default:
          return !!this.track.sum;
      }
    },
    showPaymentMethods() {
      switch (this.track.status_code) {
        case '76':
        case '150':
        case '160':
        case '165':
        case '170':
        case '180':
        case '190':
          return false;
        default:
          return !!(this.track.sum && Number(this.track.sum) !== 0 && this.track.payType);
      }
    },
    showToReceive() {
      switch (this.track.status_code) {
        case '76':
        case '150':
        case '160':
        case '165':
        case '170':
        case '180':
        case '190':
          return false;
        default:
          return !!(this.track.issueCondition && this.track.issueCondition !== '0');
      }
    },
    showStorageLife() {
      switch (this.track.status_code) {
        case '140':
          return !!(this.track.delivery_type === '1' && this.track.store_date);
        default:
          return false;
      }
    },
    showDeliveryDate() {
      return this.track.status_code !== '140' && this.track && this.track.delivery_date;
    },
    acquiring() {
      return this.odp && this.odp.acquiring;
    },
    hrefFaq() {
      return URL_PREFIX ? `${URL_PREFIX}faqItems` : '/faqItems';
    },
    historyStatuses() {
      return this.track?.Statuses || [];
    },
  },
  watch: {
    showTrackInfo(val) {
      if (val) {
        this.checkSchedule();
      }
    },
    forceOpen: {
      handler(val) {
        if (val) {
          this.onItemClick();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getPoint() {
      const self = this;
      return new Promise((resolve, reject) => {
        self.showGetPointLoader = true;
        odpRepository.default
          .find(self.track.Code)
          .then((odp) => {
            self.odp = odp.data;
            self.showGetPointLoader = false;
            resolve(self.odp);
          })
          .catch((error) => {
            self.showGetPointLoader = false;
            self.findPointError = true;

            reject(error);
          })
          .finally(() => {
            self.showGetPointLoader = false;
          });
      });
    },
    onToggleShowMap() {
      if (this.odp === null) {
        this.getPoint().then(() => {
          this.showMap = true;
        });
      } else {
        this.showMap = !this.showMap;
      }
    },
    checkSchedule() {
      if (!this.track || this.track.delivery_type !== '1') return;
      if (this.odp === null) {
        this.getPoint().then(() => {
          this.showSchedule = true;
        });
      } else {
        this.showSchedule = true;
      }
    },
    onShowModal() {
      this.showModal = true;
    },
    onHideModal() {
      this.showModal = false;
    },
    onItemClick() {
      this.showTrackInfo = !this.showTrackInfo;
    },
  },
};
</script>

<style scoped lang="scss">
  @import 'TrackWidgetItem.scss';
</style>
